import * as React from 'react';

import { observer } from 'mobx-react';

import { Button } from '@estee/elc-buttons';
import { Heading3 } from '@estee/elc-typography';

import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { classes } from '~utils/Classes';
import { isMobile } from '~utils/mobile';

import { RegisterSuccessViewController } from './RegisterSuccessViewController';

export const RegisterSuccessPage = observer(() => {
    const {
        data: { redirectUrl, message, supportingText, submitLabel }
    }: RegisterSuccessViewController = diContainer.get(serviceNames.registerSuccessViewController);

    const wrapperClassName = classes('iam-social-sign-up-register-success');
    const confirmationContainerClassName = classes('iam-confirmation-container');

    return (
        <div className={wrapperClassName}>
            <div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    preserveAspectRatio="none"
                >
                    <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
                </svg>
            </div>
            <div className={confirmationContainerClassName}>
                <Heading3>{message}</Heading3>
                <span dangerouslySetInnerHTML={{ __html: supportingText }} />
            </div>
            {!!redirectUrl ? (
                <Button
                    onClick={() =>
                        window.location.replace(isMobile ? redirectUrl?.mobile : redirectUrl?.pc)
                    }
                >
                    {submitLabel}
                </Button>
            ) : (
                <span>{submitLabel}</span>
            )}
        </div>
    );
});
